import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Progress,
} from "reactstrap";
import {
  FaEnvelope,
  FaLink,
  FaWhatsapp,
  FaFacebookMessenger,
  FaMailBulk,
} from "react-icons/fa";
import {
  Facebook,
  Twitter,
  Linkedin,
  MessageCircle,
  Copy,
} from "react-feather";
import { useNavigate } from "react-router-dom";

const ReferralComponent = ({ setModal, modal, RefferalData }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const history = useNavigate();
  const toggleModal = () => setModal(!modal);


  const stats = {
    totalReferrals: 45,
    conversions: 28,
    earnings: 890,
    progressPercentage: 75,
  };

  useEffect(() => {
    if (RefferalData) {
      setReferralCode(
        `https://www.beteljobs.com/register/${RefferalData?.refercode}` || ""
      );
    }
  }, [RefferalData]);

  // const fullReferralLink = `https://www.beteljobs.com/register/${referralCode}`;

  const copyToClipboard = () => {
    const message = `
Hi,

I would like to share an exciting platform with you 'BetelJobs'. It's an excellent website offering  part-time or full time opportunities in field audits in your own city or town. BetelJobs is built by a well known brand TRPW Strategic Partners based in India & USA.

Sign up today and start your journey towards your next career move! 🚀

 🔗 ${referralCode}

    `;
    navigator.clipboard.writeText(message);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const handleWhatsAppShare = () => {
    const message = `
Hi,

I would like to share an exciting platform with you 'BetelJobs'. It's an excellent website offering  part-time or full time opportunities in field audits in your own city or town. BetelJobs is built by a well known brand TRPW Strategic Partners based in India & USA.

Sign up today and start your journey towards your next career move! 🚀

 🔗 ${referralCode}
    `;
    const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappURL, "_blank");
  };

  const handleEmailShare = () => {
    const subject = "Join BetelJobs with my referral code!";
    const body = `
Hi,

I would like to share an exciting platform with you 'BetelJobs'. It's an excellent website offering  part-time or full time opportunities in field audits in your own city or town. BetelJobs is built by a well known brand TRPW Strategic Partners based in India & USA.

Sign up today and start your journey towards your next career move! 🚀

 🔗 ${referralCode}
    `;
    const mailtoURL = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(mailtoURL, "_self");
  };

  return (
    <Modal
      isOpen={modal}
      toggle={toggleModal}
      className="modal-dialog-centered"
    >
      <ModalHeader toggle={toggleModal}>Invite your Friends</ModalHeader>
      <ModalBody className="p-0">
        <Container className="py-4">
          <Card className="mb-4">
            <CardBody>
              <p className="h5 mb-3 text-dark">Your Referral Link</p>
              <div className="d-flex align-items-center flex-wrap">
                <div className="bg-light p-2 flex-grow-1 me-2 rounded text-truncate">
                  <span className="text-muted">{referralCode}</span>
                </div>
                <Button className="btns" onClick={copyToClipboard}>
                  <Copy size={18} className="me-2" />
                  {copySuccess ? "Copied!" : "Copy"}
                </Button>
              </div>
            </CardBody>
          </Card>

          <Card className="mb-4">
            <CardBody>
              {/* <h6 className="text-left">Share your link</h6> */}
              <Row className="text-center">
                <Col
                  xs="12"
                  md="6"
                  style={{cursor:'pointer'}}
                  className="mb-3 mb-md-0"
                  onClick={() => {
                    toggleModal();
                    history("/account", { tab: 4 });
                  }}
                >
                  <p className="h2 mb-1 text-dark">
                    {RefferalData?.refercount || 0}
                  </p>
                  <span className="text-dark">Total Referred</span>
                </Col>

                <Col
                  xs="12"
                  md="6"
                  style={{cursor:'pointer'}}
                  onClick={() => {
                    toggleModal();
                    history("/account", { tab: 4 });
                  }}
                >
                  <p className="h2 mb-1 text-dark">
                    {" "}
                    ₹ {RefferalData?.totalcredit || 0}
                  </p>
                  <span className="text-dark">Rewards Earned</span>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <p className=" mb-3  text-dark">Share Your Link</p>
              <div className="d-flex gap-3 justify-content-center">
                {/* <Button
                  outline
                  className="text-success"
                >
                  <FaFacebookMessenger
                    className="text-success mb-2"
                    size={30}
                  />
                </Button> */}
                <div
                  className="text-success  rounded "
                  style={{ cursor: "pointer", border: "1px solid #5bb360" }}
                  onClick={handleWhatsAppShare}
                >
                  <FaWhatsapp className="text-success m-2" size={30} />
                </div>
                <div
                  className="text-success  rounded ml-2"
                  style={{ cursor: "pointer", border: "1px solid gray" }}
                  onClick={handleEmailShare}
                >
                  <FaEnvelope color="gray" className="m-2" size={30} />
                </div>
              </div>
            </CardBody>
          </Card>

          {/* <div className="px-1 border mb-4">
            <ul className=" footer-social text-center">
              <h6 className="text-left">Share your link</h6>
              <li onClick={handleWhatsAppShare} className="whataap">
                <a
                  className=" bg-light"
                  style={{
                    border: "1px solid #5bb360",
                    borderRadius: "10px",
                  }}
                  href="#"
                >
                  <FaWhatsapp className="text-success mb-2" size={20} />
                </a>
              </li>
              <li onClick={handleEmailShare} className="">
                <a
                  className="bg-light"
                  href="#"
                  style={{
                    border: "1px solid #dd4d42",
                    borderRadius: "10px",
                  }}
                >
                  <FaEnvelope color="#dd4d42" className="mb-2" size={20} />
                </a>
              </li>
            </ul>
          </div> */}
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default ReferralComponent;
